// Define a constant object to store user types and their corresponding values
const USER_TYPES = {
  GLOBAL: 1, // Represents a Global user type
  BRAND: 2, // Represents a Brand user type
  PROPERTY: 3, // Represents a Property user type
  AGENCY: 4, // Represents an Agency user type
};

// Export the USER_TYPES object as the default export
export default USER_TYPES;
